import { supportState, supportActive } from '@/utils/student-support-session'

export default (to, from, next) => {
  if (supportState.mode) { next(supportActive() ? undefined : '/student-support'); return }
  if (localStorage.getItem('currentUser') !== null && localStorage.getItem('currentUser').length > 0) {
    // verify with firebase or jwt
    next()
  } else {
    localStorage.removeItem('currentUser')
    next('/user/login')
  }
}
